import { Button } from "@mui/material";
import * as React from "react";
import SelectModeBanner from "../SelectModeBanner";
import BackHandIcon from "@mui/icons-material/BackHand";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { workflowService } from "../../../Core/Api/services";
import { useTranslation } from "react-i18next";

export interface WorkflowBannerProps {
  handleCloseClick: React.MouseEventHandler;
  wks: any[];
}

const WorkflowBanner: React.FC<WorkflowBannerProps> = (props) => {
  const { t } = useTranslation();
  const { wks = [], handleCloseClick } = props;
  const enqueueCustomSnackbar = useCustomSnackbar();

  const handleClaimAll = () => {
    wks.forEach((wk) => {
      workflowService.ClaimUserTask(wk.id).then(function (response) {
        if (response.success) enqueueCustomSnackbar(t("alert:success.workflowCaimed", { id: wk.id }), "success");
        else enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { messgae: response.message }), "warning");
      });
    });
  };

  return (
    <SelectModeBanner text={t("banner:body.itemSelected", { count: wks.length })} onCloseClick={handleCloseClick}>
      <>
        <Button
          sx={{ mr: 1 }}
          startIcon={<BackHandIcon />}
          onClick={handleClaimAll}
          disabled={!wks.every((x) => x.userTasks === null || x.userTasks[0].claimInfos === null)}
        >
          {t("button:claimAll")}
        </Button>
      </>
    </SelectModeBanner>
  );
};

export default WorkflowBanner;
